// Definición de defaults

export const defaultAutoridadExhortoRecibido: AutoridadExhortoRecibidoProps = {
    idAutoridadExhortoRecibido: 0,
    descripcion:                '',
    activo:                     false,
}

// Creación de interfaces

export interface AutoridadExhortoRecibidoProps {
    idAutoridadExhortoRecibido:         number;
    descripcion:                        string;
    activo:                             boolean;
}